import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';

function BaseModal(props) {
    const modalRoot = document.getElementById(props.modalId);
    modalRoot.className = props.modalClass;

    let innerDiv = document.createElement('div');
    innerDiv.className = props.innerDivClass;

    useEffect(() => {
        /* Modal mounting */
        modalRoot.appendChild(innerDiv);
        modalRoot.style.display = "block";

        return () => {
            /* Modal unmounting */
            modalRoot.style.display = "none";
            modalRoot.removeChild(innerDiv);
        }
    });

    return ReactDOM.createPortal(props.children, innerDiv);
}

export default BaseModal;